// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageHeadContainer {
  width: 80%;
  margin: 50px auto 0px auto;
}
.pageHeadContainer > div {
  width: -moz-fit-content;
  width: fit-content;
}
.pageHeadContainer > div > div {
  background: #206d23;
  position: relative;
  z-index: 1;
  left: -20px;
  top: -30px;
  height: calc(3.5vh);
  width: calc(80%);
}

.pageHeadContainer > img {
  margin-bottom: 30px;
  width: 100%;
  object-fit: cover;
}
.pageHeadContainer > div > label {
  color: #fff;
  font-family: "Inter";
  font-size: clamp(30px, 3vw, 52px) !important;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.pageHeadContainer > p {
  color: #fff !important;
  font-family: "Open Sans";
  font-size: clamp(16px, 3vw, 24px);
  font-weight: 400;
  line-height: 38.4px;
  margin-bottom: 30px;
}
.pageHeadContainer > p > a > span {
  font-family: "Open Sans";
  font-size: clamp(16px, 3vw, 24px) !important;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  color: #fff !important;
}
@media screen and (max-width: 600px) {
  .pageHeadContainer {
    width: 90%;
    margin: 20px auto;
  }
  .pageHeadContainer > p {
    line-height: 25px;
  }
  .pageHeadContainer > div > div {
    position: relative;
    left: -10px;
    top: -20px;
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/pageHead/pageHead.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n.pageHeadContainer {\n  width: 80%;\n  margin: 50px auto 0px auto;\n}\n.pageHeadContainer > div {\n  width: fit-content;\n}\n.pageHeadContainer > div > div {\n  background: #206d23;\n  position: relative;\n  z-index: 1;\n  left: -20px;\n  top: -30px;\n  height: calc(3.5vh);\n  width: calc(80%);\n}\n\n.pageHeadContainer > img {\n  margin-bottom: 30px;\n  width: 100%;\n  object-fit: cover;\n}\n.pageHeadContainer > div > label {\n  color: #fff;\n  font-family: \"Inter\";\n  font-size: clamp(30px, 3vw, 52px) !important;\n  font-weight: 600;\n  position: relative;\n  z-index: 2;\n}\n.pageHeadContainer > p {\n  color: #fff !important;\n  font-family: \"Open Sans\";\n  font-size: clamp(16px, 3vw, 24px);\n  font-weight: 400;\n  line-height: 38.4px;\n  margin-bottom: 30px;\n}\n.pageHeadContainer > p > a > span {\n  font-family: \"Open Sans\";\n  font-size: clamp(16px, 3vw, 24px) !important;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n  color: #fff !important;\n}\n@media screen and (max-width: 600px) {\n  .pageHeadContainer {\n    width: 90%;\n    margin: 20px auto;\n  }\n  .pageHeadContainer > p {\n    line-height: 25px;\n  }\n  .pageHeadContainer > div > div {\n    position: relative;\n    left: -10px;\n    top: -20px;\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
